export const rewardsKeys = {
  get: ["rewards"],
};
